var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "52.000000pt",
    height: "68.000000pt",
    viewBox: "0 0 52.000000 68.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,68.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 335 l0 -305 248 2 247 3 3 219 2 218 -82 84 -82 84 -168 0 -168 0 0 -305z m310 195 l5 -75 73 -3 72 -3 0 -194 0 -195 -215 0 -215 0 0 275 0 276 138 -3 137 -3 5 -75z m120 -37 c0 -2 -20 -3 -45 -3 l-45 0 0 47 0 47 45 -44 c25 -24 45 -45 45 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 367 c-27 -49 -31 -52 -67 -52 -85 0 -126 -102 -66 -162 36 -37 95 -38 131 -4 14 14 26 30 26 37 0 9 21 14 70 16 l70 3 -62 108 c-34 59 -65 107 -68 107 -3 0 -19 -24 -34 -53z m94 -119 c0 -5 -15 -8 -33 -8 -26 0 -35 6 -46 30 -11 27 -11 34 4 57 l17 26 29 -49 c16 -27 29 -52 29 -56z m-118 15 c22 -20 23 -61 1 -85 -34 -38 -103 -11 -103 40 0 54 62 81 102 45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.a922acdb.svg";
export { ForwardRef as ReactComponent };